import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ProfileButton from "@app/components/ProfileButton";
import EditIcon from "@app/icons/Edit";
import { useParams } from "react-router";
import useUser from "@app/zustand/user";
import ButtonBlock from "@app/components/ButtonBlock";
import { UserSearched } from "@api/src/types/user";
import { UserGetResponse } from "@api/src/types/responses";
import Loader from "@app/icons/Loader";
import ButtonWrite from "@app/components/ButtonWrite";
import ProfileEdit from "./profile.edit";

export default function Profile() {
  const params = useParams();
  const userId = params.id;
  const me = useUser((state) => state.user!);
  const [userSearched, setUser] = useState<UserSearched | null>(null);
  const navigate = useNavigate();
  const [openEditProfile, setOpenEditProfile] = useState(false);
  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_URL}/users/${userId}`, {
      credentials: "include",
    })
      .then((res) => res.json() as Promise<UserGetResponse>)
      .then((data) => setUser(data.data.user));
  }, [userId]);
  const isMe = userSearched?.id === me.id;
  const user = isMe ? me : userSearched;

  if (!user) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader />
      </div>
    );
  }

  const place = `${user.hopital ? `${user.hopital} - ` : ""}${user.service}`;
  return (
    <>
      <div className="relative mt-4 flex w-full flex-col overflow-y-auto md:px-6 bg-white pt-4">
        <ProfileButton
          className={[
            "z-10 ml-4 h-40 w-40 rounded-full border-4 text-6xl font-semibold sm:ml-16",
            user.avatar ? "border-white" : "border-sky-900",
          ].join(" ")}
          user={user}
        />
        <div className="flex w-full">
          <section className="relative mt-2 flex flex-1 flex-col px-4 sm:px-16">
            {isMe && (
              <button
                onClick={() => setOpenEditProfile(true)}
                type="button"
                className="absolute -top-12 right-2 cursor-pointer rounded-full border-2 border-sky-900 bg-white p-1 text-sky-900  opacity-30 hover:opacity-100"
              >
                <EditIcon />
              </button>
            )}
            <h1 className="text-xl font-bold">
              {user.firstName} {user.lastName}
            </h1>
            <span>{user.specialite}</span>
            <span>{user.status_pro}</span>
            <span className="text-sm text-gray-400">{place}</span>
          </section>
        </div>
        {!isMe && (
          <section className="flex flex-1 flex-col items-start justify-start gap-2 w-full mt-10 px-4 sm:px-16">
            <ButtonWrite user={user} isInTheRoom={false} numberOfUsersInTheRoom={0} />
            <ButtonBlock
              user={user}
              className="rounded-full border border-sky-900 px-4 py-1"
              onBlocked={() => {
                console.log("blocked");
                navigate("/");
              }}
            />
          </section>
        )}
      </div>
      <ProfileEdit open={openEditProfile} setOpen={setOpenEditProfile} />
    </>
  );
}
